import { CONTAINS, IS_EMPTY, IS_NOT_EMPTY, IS_NOT_ONE_OF, IS_ONE_OF, NOT_CONTAINS, STARTS_WITH } from '../filter-conditions.js';
export const boardRelationFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    IS_EMPTY,
    IS_NOT_EMPTY,
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
];
//# sourceMappingURL=filters.js.map